// extracted by mini-css-extract-plugin
export default {"additionalText":"ObjectAccessories_additionalText__soMIW","camerasDropdown":"ObjectAccessories_camerasDropdown__34ifF","dropdownBtn":"ObjectAccessories_dropdownBtn__WX7iB"};